import { DialogCentered, DialogCenteredProps } from '../DialogCentered';
import { WizardStore, WizardElementProps, withoutWizardProps } from './Wizard';
import { WizardContainer, WizardContainerProps } from './WizardContainer';

export type WizardDialogProps = WizardContainerProps & DialogCenteredProps;

export const WizardDialog = withoutWizardProps(
  (props: WizardDialogProps & WizardElementProps<WizardStore, string>) => {
    return WizardContainer(props, ({ children, open, ...containerProps }) => {
      return (
        <DialogCentered
          {...props}
          {...containerProps}
          onClose={() => {
            return containerProps.go(undefined);
          }}
          open={open}
          showCloseIcon={false}
        >
          {children}
        </DialogCentered>
      );
    });
  },
);
